import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import { createStyles, makeStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

import { ReactComponent as HuFlag } from 'flag-icon-css/flags/4x3/hu.svg';
import { ReactComponent as EnFlag } from 'flag-icon-css/flags/4x3/us.svg';

const languages = [
  {
    flag: HuFlag,
    code: 'hu',
    label: 'Magyar',
  },
  {
    flag: EnFlag,
    code: 'en',
    label: 'English',
  },
];

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexWrap: 'wrap',
    },
    formControl: {
      margin: theme.spacing(1),
      '& .MuiInput-underline:before, & .MuiInput-underline:after, & .MuiSelect-icon': {
        display: 'none',
      },
      '& .MuiSelect-select': {
        minWidth: 'unset',
        paddingRight: 0,
        display: 'flex',
        '& .langTextContainer': {
          display: 'none',
        },
      },
      '& .MuiSelect-select:focus': {
        backgroundColor: 'transparent',
      },
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
    langText: {
      marginLeft: theme.spacing(1),
    },
    flag: {
      width: 20,
    },
  })
);

const LanguageSelect = () => {
  const classes = useStyles();
  const { i18n } = useTranslation();
  const [value, setValue] = React.useState(i18n.language);

  const handleChange = async (event) => {
    const lang = event.target.value;
    await i18n.changeLanguage(lang === 'gb' ? 'en' : lang);
    setValue(lang);
  };

  return (
    <form className={classes.root} autoComplete="off">
      <FormControl className={classes.formControl}>
        <Select value={(value || '').toLowerCase().substring(0, 2)} onChange={handleChange}>
          {languages.map((language) => (
            <MenuItem value={language.code} key={language.code}>
              <language.flag className={classes.flag} />
              <span className={classNames('langTextContainer', classes.langText)}>{language.label}</span>
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </form>
  );
};

export default LanguageSelect;
